import { api } from './api'
import type { NotificationDto, NotificationListResponse } from '@toga/shared'

export type { NotificationDto, NotificationListResponse }

export async function fetchNotifications(opts?: {
  unreadOnly?: boolean
  limit?: number
}): Promise<NotificationListResponse> {
  const params = new URLSearchParams()
  if (opts?.unreadOnly) params.set('unreadOnly', 'true')
  if (opts?.limit) params.set('limit', String(opts.limit))
  const qs = params.toString()
  return api.get<NotificationListResponse>(`/notifications${qs ? `?${qs}` : ''}`)
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await api.get<NotificationListResponse>('/notifications?unreadOnly=true&limit=1')
  return res.unreadCount
}

export async function markRead(id: string): Promise<NotificationDto> {
  const res = await api.post<{ notification: NotificationDto }>(
    `/notifications/${id}/read`,
  )
  return res.notification
}

export async function markAllRead(): Promise<number> {
  const res = await api.post<{ updated: number }>('/notifications/mark-all-read')
  return res.updated
}

export async function deleteNotification(id: string): Promise<void> {
  await api.delete<void>(`/notifications/${id}`)
}

// ---------- helpers de presentación ----------

export function relativeTime(iso: string): string {
  const now = Date.now()
  const then = new Date(iso).getTime()
  const diffSec = Math.round((now - then) / 1000)
  if (diffSec < 60) return 'hace unos segundos'
  const diffMin = Math.round(diffSec / 60)
  if (diffMin < 60) return `hace ${diffMin} min`
  const diffHrs = Math.round(diffMin / 60)
  if (diffHrs < 24) return `hace ${diffHrs} h`
  const diffDays = Math.round(diffHrs / 24)
  if (diffDays === 1) return 'ayer'
  if (diffDays < 7) return `hace ${diffDays} días`
  const diffWeeks = Math.round(diffDays / 7)
  if (diffWeeks < 5) return `hace ${diffWeeks} sem`
  const diffMonths = Math.round(diffDays / 30)
  if (diffMonths < 12) return `hace ${diffMonths} meses`
  return `hace ${Math.round(diffMonths / 12)} años`
}

export function isToday(iso: string): boolean {
  const d = new Date(iso)
  const today = new Date()
  return (
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate()
  )
}
